import React from 'react';
export const MOBILE_MODE = process.env.REACT_APP_MOBILE && process.env.REACT_APP_MOBILE === 'true';
export const APP_VERSION = process.env.REACT_APP_APP_VERSION;
export const API_URL = MOBILE_MODE ? process.env['REACT_APP_API_URL'] || '' : '';
// console.log("API_URL",API_URL);

export const appEmail = "srv_dsy@acri-st.fr";
export const appAdress = <>260 Route du Pin Montard<br/>06410 Biot<br/>France</>;
export const appPhone = "+33 (0)4 92 967 500";